import React from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";
/**
 *
 * @param {any} item object containing  room search item
 */
function RoomSearchDetail({ item }) {
    return (
        <>
            <div className="row">
                <div className="col-4 bg-primary pl-3">
                    <h5>Search Detail</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Date of Search*</strong>
                            </td>
                            <td>{cleanDate(item.searchDate, true)}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Start Time of Search*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <p>{item.startTime}</p>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>End Time of Search*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <p>{item.endTime}</p>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Patient Consent*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <p>{item.consent}</p>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Patient Present*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <p>{item.present}</p>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Justification For Search *</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <p>{item.reason}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-4 bg-primary pl-3">
                    <h5>Search Members</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Search Member*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <ul>
                                    {item.members.map((c, i) => (
                                        <li key={i} className="fade-in">
                                            <StaffProfileCard key={i} item={c} />
                                        </li>
                                    ))}
                                </ul>

                                {!item.members.length && <p className="text-pink fade-in">No Search Team!</p>}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-4 bg-primary pl-3">
                    <h5>Damage Report</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Prior to Search*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <p>{item.priorToSearch}</p>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%", backgroundColor: "aliceblue" }}>
                                <strong>Post Search*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <p>{item.postToSearch}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-4 bg-primary pl-3">
                    <h5>Comments and Observations</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td>
                                <p>{item.comment}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default RoomSearchDetail;
